/**
 * @group Models
 */
export type Locale =
    "af" |
    "ar" |
    "arDZ" |
    "arMA" |
    "arSA" |
    "az" |
    "be" |
    "bg" |
    "bn" |
    "ca" |
    "cs" |
    "cy" |
    "da" |
    "de" |
    "el" |
    "enAU" |
    "enCA" |
    "enGB" |
    "enIN" |
    "enNZ" |
    "enUS" |
    "eo" |
    "es" |
    "et" |
    "eu" |
    "faIR" |
    "fi" |
    "fil" |
    "fr" |
    "frCA" |
    "frCH" |
    "gd" |
    "gl" |
    "gu" |
    "he" |
    "hi" |
    "hr" |
    "hu" |
    "hy" |
    "id" |
    "is" |
    "it" |
    "ja" |
    "ka" |
    "kk" |
    "kn" |
    "ko" |
    "lb" |
    "lt" |
    "lv" |
    "mk" |
    "ms" |
    "mt" |
    "nb" |
    "nl" |
    "nlBE" |
    "nn" |
    "pl" |
    "pt" |
    "ptBR" |
    "ro" |
    "ru" |
    "sk" |
    "sl" |
    "sr" |
    "srLatn" |
    "sv" |
    "ta" |
    "te" |
    "th" |
    "tr" |
    "ug" |
    "uk" |
    "uz" |
    "vi" |
    "zhCN" |
    "zhTW";
